import React from 'react'
import { Box, Typography } from '@mui/material'
import Navbar from './Navbar'
import { usePublicAppInfo } from '../../hooks/usePublicAppInfo'
import SpeedtestStatus from './SpeedtestStatus'

interface DashboardLayoutProps {
  children: React.ReactNode
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  const { appInfo } = usePublicAppInfo()
  const navbarHeight = 33
  const navbarGap = 6
  const topOffset = navbarHeight + navbarGap

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* Navbar */}
      <Navbar 
        onMenuClick={() => {}} // Nu mai este folosit
      />

      {/* Main content area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
        }}
      >
        {/* Page content */}
        <Box
          sx={{
            flexGrow: 1,
            backgroundColor: 'background.default',
            minHeight: `calc(100vh - ${topOffset}px - 40px)`, // Subtract navbar + gap and footer heights
            mt: `${topOffset}px`, // Spațiu pentru navbar + gap (evită overlay)
          }}
        >
          {children}
        </Box>

        {/* Footer */}
        <Box
          sx={{
            height: 40,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'background.paper',
            borderTop: 1,
            borderColor: 'divider',
            px: 2,
            gap: 1.5,
            flexWrap: 'wrap',
          }}
        >
          <Typography 
            variant="body2" 
            color="text.secondary"
            sx={{ fontSize: '0.75rem' }}
          >
            {appInfo.app_name || 'ZenRIS'} v{appInfo.app_version || '-'} {appInfo.build_number && appInfo.build_number !== '-' && appInfo.build_number !== 'N/A' ? `(${appInfo.build_number})` : ''}
          </Typography>
          <Typography 
            variant="body2" 
            color="text.secondary"
            sx={{ fontSize: '0.75rem' }}
          >
            |
          </Typography>
          <SpeedtestStatus />
        </Box>
      </Box>
    </Box>
  )
}

export default DashboardLayout
